import React from "react";

const UserPage = () => {
  return (
    <div className="">
      <h1 className="m-7 flex flex-col items-start gap-2 text-xl">
        <span className="bg-bgBlackGray px-4 py-3 text-white">WELCOME TO</span>
        <span className="bg-bgBlackGray px-4 py-3 text-white">
          YOUR ACCOUNT
        </span>
      </h1>
    </div>
  );
};

export default UserPage;
